import React, { useState, useEffect, useContext } from 'react';
import './ApiModel.css';
import { getToken } from '../../function/token';
import domain from '../../../reusecomponent/domain';
import Preloader from '../preloader';
import Swal from 'sweetalert2';
import { ThemeContext } from '../../../routing/ApplicationRouting';

const ApiModel = () => {
    const theme = useContext(ThemeContext);
    const [apis, setApis] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [filters, setFilters] = useState({
        status: 'Any Status',
        verification: 'Any Verification',
        search: ''
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [bodyFormat, setBodyFormat] = useState('DEFAULT');
    const [headerData, setHeaderData] = useState([]);
    const [showHeaderForm, setShowHeaderForm] = useState(false);
    const [newHeader, setNewHeader] = useState({
        key: '',
        type: 'Static Value',
        value: ''
    });
    const [bodyData, setBodyData] = useState([]);
    const [showBodyForm, setShowBodyForm] = useState(false);
    const [newBody, setNewBody] = useState({
        key: '',
        type: 'Static Value',
        value: ''
    });
    const [jsonData, setJsonData] = useState('');
    const [variablesSearch, setVariablesSearch] = useState('');
    const [availableVariables] = useState([
        '#LEAD_USER_FIRST_NAME#',
        '#LEAD_USER_EMAIL#',
        '#LEAD_USER_CHAT_ID#',
        '#LEAD_USER_SUBSCRIBER_ID#'
    ]);
    const [apiLoader, setApiLoader] = useState(false);
    const [endpointUrl, setEndpointUrl] = useState('');
    const [method, setMethod] = useState('POST');
    const [modelName, setModelName] = useState('');
    const [testLoadingId, setTestLoadingId] = useState(null);
    const [showTestPanel, setShowTestPanel] = useState(false);
    const [testResponse, setTestResponse] = useState(null);
    const [testRequest, setTestRequest] = useState(null);
    const [selectedApiForTest, setSelectedApiForTest] = useState(null);
    const [createApiLoading, setCreateApiLoading] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingApiId, setEditingApiId] = useState(null);
    const [editLoading, setEditLoading] = useState(false);
    
    // Load data on component mount - MUST be called before any conditional returns
    useEffect(() => {
        fetchApiModels();
    }, []);

   

    // API Integration Functions with Console Logging

    // Function to save header data to API
    const saveHeaderDataToAPI = async (headerData) => {
        console.log('=== SAVING HEADER DATA TO API ===');
        console.log('Header Data to be saved:', headerData);
        
        const token = getToken();
        if (!token) {
            console.error('No authentication token found!');
            return;
        }

        const myHeaders = new Headers();
        myHeaders.append('Authorization', `Bearer ${token}`);
        myHeaders.append('Content-Type', 'application/json');

        // Convert header data to array format [key: value] and then to JSON string
        const headersArray = headerData.map(header => ({
            [header.key]: header.value
        }));
        
        // Convert headers array to JSON string as required by the API
        //const headersString = JSON.stringify(headersArray);
        const headersString = headersArray;


        const requestData = {
            model_name: modelName || "default_model",
            url: endpointUrl || `${domain()}/send-message`, // Use dynamic URL
            method: method || "POST", // Use dynamic method
            header: headersString, // Send as JSON string instead of array
            form_data: [],
            x_www_form_urlencoded_data: "",
            raw_data: "",
            binary_data: ""
        };

        console.log('Request Data for API Model:', requestData);

        try {
            const response = await fetch(`${domain()}/api_model`, {
                method: 'POST',
                header: myHeaders,
                body: JSON.stringify(requestData)
            });

            const result = await response.json();
            console.log('API Model Response:', result);
            
            if (result.status) {
                console.log('✅ Header data saved successfully!');
                return result;
            } else {
                console.error('❌ Failed to save header data:', result.message);
                return null;
            }
        } catch (error) {
            console.error('❌ Error saving header data:', error);
            return null;
        }
    };

    // Function to save body data to API (for DEFAULT, FORM-DATA, X-WWW-FORM-URLENCODED)
    const saveBodyDataToAPI = async (bodyData, format) => {
        console.log('=== SAVING BODY DATA TO API ===');
        console.log('Body Data to be saved:', bodyData);
        console.log('Body Format:', format);
        
        const token = getToken();
        if (!token) {
            console.error('No authentication token found!');
            return;
        }

        const myHeaders = new Headers();
        myHeaders.append('Authorization', `Bearer ${token}`);
        myHeaders.append('Content-Type', 'application/json');

        // Convert body data based on format
        let form_data = [];
        let x_www_from_urlencoded_data = "";
        let raw_data = "";

        if (format === 'FORM-DATA') {
            form_data = bodyData.map(body => ({
                key: body.key,
                value: body.value
            }));
        } else if (format === 'X-WWW-FORM-URLENCODED') {
            x_www_from_urlencoded_data = bodyData.map(body => 
                `${encodeURIComponent(body.key)}=${encodeURIComponent(body.value)}`
            ).join('&');
        } else if (format === 'DEFAULT') {
            // For DEFAULT, we'll use raw_data as JSON
            const jsonObject = {};
            bodyData.forEach(body => {
                jsonObject[body.key] = body.value;
            });
            raw_data = JSON.stringify(jsonObject);
        }

        // Convert form_data array to JSON string as required by the API
        const formDataString = JSON.stringify(form_data);

        const requestData = {
            model_name: modelName || "default_model",
            url: endpointUrl, 
            method: method,
            header: "[]", // Empty JSON string for headers in body data
            form_data: formDataString, // Send as JSON string instead of array
            x_www_form_urlencoded_data: x_www_from_urlencoded_data,
            raw_data: raw_data,
            binary_data: ""
        };

        console.log('Request Data for API Model:', requestData);

        try {
            const response = await fetch(`${domain()}/api_model`, {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify(requestData)
            });

            const result = await response.json();
            console.log('API Model Response:', result);
            
            if (result.status) {
                console.log('✅ Body data saved successfully!');
                return result;
            } else {
                console.error('❌ Failed to save body data:', result.message);
                return null;
            }
        } catch (error) {
            console.error('❌ Error saving body data:', error);
            return null;
        }
    };

    // Function to save JSON data to API
    const saveJsonDataToAPI = async (jsonData) => {
        console.log('=== SAVING JSON DATA TO API ===');
        console.log('JSON Data to be saved:', jsonData);
        
        const token = getToken();
        if (!token) {
            console.error('No authentication token found!');
            return;
        }

        const myHeaders = new Headers();
        myHeaders.append('Authorization', `Bearer ${token}`);
        myHeaders.append('Content-Type', 'application/json');

        // Validate JSON format
        let parsedJson;
        try {
            parsedJson = JSON.parse(jsonData);
            console.log('Parsed JSON is valid:', parsedJson);
        } catch (error) {
            console.error('❌ Invalid JSON format:', error);
            return null;
        }

        const requestData = {
            model_name: modelName || "default_model",
            url: endpointUrl || "https://api.campaigningtool.com/api/send-message", // Use dynamic URL
            method: method || "POST", // Use dynamic method
            headers: [
               
            ],
            form_data: [],
            x_www_form_urlencoded_data: "",
            raw_data: jsonData,
            binary_data: ""
        };

        console.log('Request Data for API Model:', requestData);

        try {
            const response = await fetch(`${domain()}/api_model`, {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify(requestData)
            });

            const result = await response.json();
            console.log('API Model Response:', result);
            
            if (result.status) {
                console.log('✅ JSON data saved successfully!');
                return result;
            } else {
                console.error('❌ Failed to save JSON data:', result.message);
                return null;
            }
        } catch (error) {
            console.error('❌ Error saving JSON data:', error);
            return null;
        }
    };

    // Function to test API connection with all data
    const testApiConnection = async () => {
        console.log('=== TESTING API CONNECTION WITH ALL DATA ===');
        console.log('Current Header Data:', headerData);
        console.log('Current Body Data:', bodyData);
        console.log('Current JSON Data:', jsonData);
        console.log('Current Body Format:', bodyFormat);
        console.log('Current Endpoint URL:', endpointUrl);
        console.log('Current Method:', method);
        
        // Validate that we have a URL and method
        if (!endpointUrl || !endpointUrl.trim()) {
            alert('Please enter an endpoint URL before testing the API connection.');
            return;
        }
        
        if (!method || !method.trim()) {
            alert('Please select a method before testing the API connection.');
            return;
        }
        
        setApiLoader(true);

        try {
            // Prepare the complete API model data
            const token = getToken();
            const myHeaders = new Headers();
            myHeaders.append('Authorization', `Bearer ${token}`);
            myHeaders.append('Content-Type', 'application/json');

            // Convert header data to array format [key: value] and then to JSON string
            const headersArray = headerData.map(header => ({
                [header.key]: header.value
            }));
            
            // Convert body data based on format
            let form_data = [];
            let x_www_from_urlencoded_data = "";
            let raw_data = "";
            let finalHeadersArray = [...headersArray];

            if (bodyFormat === 'JSON' && jsonData.trim()) {
                raw_data = jsonData;
                // Add Content-Type header
                finalHeadersArray.push({ "Content-Type": "application/json" });
            } else if (bodyFormat === 'FORM-DATA' && bodyData.length > 0) {
                form_data = bodyData.map(body => ({
                    key: body.key,
                    value: body.value
                }));
            } else if (bodyFormat === 'X-WWW-FORM-URLENCODED' && bodyData.length > 0) {
                x_www_from_urlencoded_data = bodyData.map(body => 
                    `${encodeURIComponent(body.key)}=${encodeURIComponent(body.value)}`
                ).join('&');
            } else if (bodyFormat === 'DEFAULT' && bodyData.length > 0) {
                const jsonObject = {};
                bodyData.forEach(body => {
                    jsonObject[body.key] = body.value;
                });
                raw_data = JSON.stringify(jsonObject);
            }

            // Convert final headers array to JSON string as required by the API
            // const headersString = JSON.stringify(finalHeadersArray);
            const headersString = finalHeadersArray;

            const completeRequestData = {
                model_name: modelName || "default_model",
                url: endpointUrl, // Use dynamic value
                method: method,   // Use dynamic value
                header: headersString, // Send as JSON string instead of array
                form_data: form_data,
                x_www_form_urlencoded_data: x_www_from_urlencoded_data,
                raw_data: raw_data,
                binary_data: ""
            };

            console.log('Complete API Model Request Data:', completeRequestData);

            const response = await fetch(`${domain()}/api_model`, {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify(completeRequestData)
            });

            const result = await response.json();
            console.log('✅ API Model Test Result:', result);
            
            if (result.status) {
                console.log('🎉 API model test successful!');
                alert('API model test successful!');
            } else {
                console.error('❌ API model test failed:', result.message);
                alert('API model test failed: ' + result.message);
            }

        } catch (error) {
            console.error('❌ Error during API model test:', error);
            alert('Error during API model test: ' + error.message);
        } finally {
            setApiLoader(false);
        }
    };

    // Function to load existing API data
    const loadApiData = async () => {
        console.log('=== LOADING EXISTING API DATA ===');
        
        const token = getToken();
        if (!token) {
            console.error('No authentication token found!');
            return;
        }

        const myHeaders = new Headers();
        myHeaders.append('Authorization', `Bearer ${token}`);

        try {
            const response = await fetch(`${domain()}/api_model`, {
                method: 'GET',
                headers: myHeaders
            });

            const result = await response.json();
            console.log('Loaded API Model Data:', result);
            
            if (result.status && result.data) {
                // Load header data
                            if (result.data.headers) {
                const headerArray = Object.entries(result.data.headers).map(([key, value]) => ({
                        id: Date.now() + Math.random(),
                        key: key,
                        type: 'Static Value',
                        value: value
                    }));
                    setHeaderData(headerArray);
                    console.log('✅ Header data loaded:', headerArray);
                }

                // Load body data based on format
                if (result.data.form_data && result.data.form_data.length > 0) {
                    setBodyFormat('FORM-DATA');
                    const bodyArray = result.data.form_data.map(item => ({
                        id: Date.now() + Math.random(),
                        key: item.key,
                        type: 'Static Value',
                        value: item.value
                    }));
                    setBodyData(bodyArray);
                    console.log('✅ Form data loaded:', bodyArray);
                } else if (result.data.x_www_form_urlencoded_data) {
                    setBodyFormat('X-WWW-FORM-URLENCODED');
                    const params = new URLSearchParams(result.data.x_www_form_urlencoded_data);
                    const bodyArray = Array.from(params.entries()).map(([key, value]) => ({
                        id: Date.now() + Math.random(),
                        key: key,
                        type: 'Static Value',
                        value: value
                    }));
                    setBodyData(bodyArray);
                    console.log('✅ URL encoded data loaded:', bodyArray);
                } else if (result.data.raw_data) {
                    try {
                        const parsedData = JSON.parse(result.data.raw_data);
                        if (typeof parsedData === 'object' && !Array.isArray(parsedData)) {
                            setBodyFormat('DEFAULT');
                            const bodyArray = Object.entries(parsedData).map(([key, value]) => ({
                                id: Date.now() + Math.random(),
                                key: key,
                                type: 'Static Value',
                                value: String(value)
                            }));
                            setBodyData(bodyArray);
                            console.log('✅ Raw data loaded as DEFAULT format:', bodyArray);
                        } else {
                            setBodyFormat('JSON');
                            setJsonData(result.data.raw_data);
                            console.log('✅ Raw data loaded as JSON format:', result.data.raw_data);
                        }
                    } catch (error) {
                        setBodyFormat('JSON');
                        setJsonData(result.data.raw_data);
                        console.log('✅ Raw data loaded as JSON format:', result.data.raw_data);
                    }
                }
            }
        } catch (error) {
            console.error('❌ Error loading API model data:', error);
        }
    };

    // Function to fetch API models
    const fetchApiModels = async () => {
        try {
            setLoading(true);
            const token = getToken();
            const myHeaders = new Headers();
            myHeaders.append('Authorization', `Bearer ${token}`);
            myHeaders.append('Content-Type', 'application/json');

            const response = await fetch(`${domain()}/api_model`, {
                method: 'GET',
                headers: myHeaders
            });

            const result = await response.json();
            
            if (result.status && result.data) {
                // Transform API data to match our component structure
                const transformedApis = result.data.map((api, index) => ({
                    id: api.id,
                    name: `API ${api.id}`,
                    endpointUrl: api.url,
                    method: api.method,
                    channel: 'WhatsApp', // Default channel
                    status: true, // Default status
                    verified: true, // Default verified status
                    createdAt: new Date(api.created_at).toLocaleDateString('en-GB', {
                        day: 'numeric',
                        month: 'short',
                        year: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                    }),
                    lastCalledAt: new Date(api.updated_at).toLocaleDateString('en-GB', {
                        day: 'numeric',
                        month: 'short',
                        year: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                    }),
                    headers: api.headers,
                    formData: api.form_data,
                    xWwwFormUrlencodedData: api.x_www_from_urlencoded_data,
                    rawData: api.raw_data,
                    binaryData: api.binary_data
                }));
                setApis(transformedApis);
            } else {
                setApis([]);
            }
        } catch (error) {
            console.error('Error fetching API models:', error);
            setApis([]);
        } finally {
            setLoading(false);
        }
    };



    const handleStatusToggle = (apiId) => {
        setApis(apis.map(api => 
            api.id === apiId ? { ...api, status: !api.status } : api
        ));
    };

    const handleEdit = async (apiId) => {
        try {
            // Show loader immediately when edit button is clicked
            setEditLoading(true);
            
            const token = getToken();
            const myHeaders = new Headers();
            myHeaders.append('Authorization', `Bearer ${token}`);
            myHeaders.append('Content-Type', 'application/json');
            
            const response = await fetch(`${domain()}/api_model/${btoa(apiId)}`, {
                method: 'GET',
                headers: myHeaders
            });
            
            const result = await response.json();
            if (result.status) {
                // Load the API data into the form for editing
                const apiData = result.data;
                
                console.log('🔍 Full API data received:', apiData);
                console.log('🔍 Headers field value:', apiData.headers);
                console.log('🔍 Headers field type:', typeof apiData.headers);
                
                // Set basic form fields
                setEndpointUrl(apiData.url || '');
                setMethod(apiData.method || 'GET');
                setModelName(apiData.model_name || '');
                
                // Load header data
                console.log('🔍 Raw headers data:', apiData.headers);
                if (apiData.headers && apiData.headers.trim()) {
                    try {
                        // Parse the headers JSON string
                        const headersArray = JSON.parse(apiData.headers);
                        console.log('🔍 Parsed headers array:', headersArray);
                        if (Array.isArray(headersArray) && headersArray.length > 0) {
                            const headerArray = headersArray.map(header => {
                                const key = Object.keys(header)[0];
                                const value = header[key];
                                return {
                                    id: Date.now() + Math.random(),
                                    key: key,
                                    type: 'Static Value',
                                    value: value,
                                    readOnly: true // Set as read-only initially
                                };
                            });
                            setHeaderData(headerArray);
                            console.log('✅ Headers loaded for editing:', headerArray);
                        } else {
                            console.log('⚠️ Headers array is empty or not an array');
                            setHeaderData([]);
                        }
                    } catch (error) {
                        console.error('❌ Error parsing headers JSON:', error);
                        setHeaderData([]);
                    }
                } else if (apiData.header && Array.isArray(apiData.header) && apiData.header.length > 0) {
                    // Fallback to header field if headers field is not available
                    const headerArray = apiData.header.map(header => {
                        const key = Object.keys(header)[0];
                        const value = header[key];
                        return {
                            id: Date.now() + Math.random(),
                            key: key,
                            type: 'Static Value',
                            value: value,
                            readOnly: true // Set as read-only initially
                        };
                    });
                    setHeaderData(headerArray);
                    console.log('✅ Headers loaded for editing (fallback):', headerArray);
                } else {
                    console.log('⚠️ No headers data found');
                    setHeaderData([]);
                }
                
               
                
                if (apiData.form_data && apiData.form_data.trim()) {
                    console.log('🔍 Form data detected:', apiData.form_data);
                    try {
                        // Parse the form_data JSON string
                        const formDataArray = JSON.parse(apiData.form_data);
                        console.log('🔍 Parsed form data array:', formDataArray);
                        if (Array.isArray(formDataArray) && formDataArray.length > 0) {
                            // Form data format
                            console.log('🔍 Setting body format to FORM-DATA');
                            setBodyFormat('FORM-DATA');
                            const bodyArray = formDataArray.map(item => ({
                                id: Date.now() + Math.random(),
                                key: item.key,
                                type: 'Static Value',
                                value: item.value,
                                readOnly: true // Set as read-only initially
                            }));
                            setBodyData(bodyArray);
                            setJsonData('');
                            console.log('✅ Form data loaded for editing:', bodyArray);
                        } else {
                            console.log('⚠️ Form data array is empty or not an array');
                            setBodyData([]);
                            setJsonData('');
                        }
                    } catch (error) {
                        console.error('❌ Error parsing form_data JSON:', error);
                        setBodyData([]);
                        setJsonData('');
                    }
                } else if (apiData.x_www_form_urlencoded_data && apiData.x_www_form_urlencoded_data.trim()) {
                    // URL encoded format
                    setBodyFormat('X-WWW-FORM-URLENCODED');
                    try {
                        const params = new URLSearchParams(apiData.x_www_form_urlencoded_data);
                        const bodyArray = Array.from(params.entries()).map(([key, value]) => ({
                            id: Date.now() + Math.random(),
                            key: key,
                            type: 'Static Value',
                            value: value,
                            readOnly: true // Set as read-only initially
                        }));
                        setBodyData(bodyArray);
                        setJsonData('');
                        console.log('✅ URL encoded data loaded for editing:', bodyArray);
                    } catch (error) {
                        console.error('Error parsing URL encoded data:', error);
                        setBodyData([]);
                        setJsonData('');
                    }
                } else if (apiData.raw_data && apiData.raw_data.trim()) {
                    // Raw data detected - always treat as JSON format to preserve the original structure
                   
                    try {
                        const parsedData = JSON.parse(apiData.raw_data);
                       
                        
                        
                        setBodyFormat('JSON');
                        setJsonData(apiData.raw_data);
                        setBodyData([]);
                        console.log('✅ Raw data loaded as JSON format for editing:', apiData.raw_data);
                    } catch (error) {
                        // Even if it's not valid JSON, still treat as JSON format for raw text
                        setBodyFormat('JSON');
                        setJsonData(apiData.raw_data);
                        setBodyData([]);
                        console.log('✅ Raw data loaded as JSON format for editing:', apiData.raw_data);
                    }
                } else {
                    // No body data
                    console.log('🔍 No body data found, setting format to DEFAULT');
                    setBodyFormat('DEFAULT');
                    setBodyData([]);
                    setJsonData('');
                }
                
                // Set edit mode
                setIsEditMode(true);
                setEditingApiId(apiId);
                
                // Hide loader after data is loaded
                setEditLoading(false);
                
                // Show success message
                Swal.fire({
                    title: 'API Loaded!',
                    text: 'API configuration has been loaded for editing. You can now modify the settings.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
                
                console.log('✅ API data loaded for editing:', apiData);
            } else {
                // Hide loader on error
                setEditLoading(false);
                Swal.fire({
                    title: 'Error!',
                    text: `Failed to load API for editing: ${result.message}`,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            // Hide loader on error
            setEditLoading(false);
            Swal.fire({
                title: 'Error!',
                text: `Error loading API for editing: ${error.message}`,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const handleShare = async (apiId) => {
        try {
            const api = apis.find(api => api.id === apiId);
            if (api) {
                const shareData = {
                    name: api.name,
                    url: api.endpointUrl,
                    method: api.method,
                    headers: api.headers,
                    formData: api.formData,
                    rawData: api.rawData
                };
                
                // Copy to clipboard
                await navigator.clipboard.writeText(JSON.stringify(shareData, null, 2));
                alert('API configuration copied to clipboard!');
            }
        } catch (error) {
            alert('Error sharing API: ' + error.message);
        }
    };

    const handleTest = async (apiId) => {
        setTestLoadingId(apiId);
        setShowTestPanel(true);
        
        // Find the selected API
        const selectedApi = apis.find(api => api.id === apiId);
        setSelectedApiForTest(selectedApi);
        
        try {
            const token = getToken();
            const myHeaders = new Headers();
            myHeaders.append('Authorization', `Bearer ${token}`);
            myHeaders.append('Content-Type', 'application/json');
            
            // Prepare request data for display
            let headersArray = [];
            if (selectedApi?.headers) {
                if (typeof selectedApi.headers === 'string' && selectedApi.headers.trim()) {
                    try {
                        const parsedHeaders = JSON.parse(selectedApi.headers);
                        if (Array.isArray(parsedHeaders)) {
                            headersArray = parsedHeaders;
                        }
                    } catch (error) {
                        console.error('Error parsing headers:', error);
                    }
                } else if (Array.isArray(selectedApi.headers)) {
                    headersArray = selectedApi.headers;
                }
            }
            
            const requestData = {
                url: selectedApi?.endpointUrl || '',
                method: selectedApi?.method || 'GET',
                headers: headersArray,
                body: selectedApi?.rawData || null
            };
            setTestRequest(requestData);
            
            const response = await fetch(`${domain()}/api_model/test/${btoa(apiId)}`, {
                method: 'POST',
                headers: myHeaders
            });
            
            const result = await response.json();
            setTestResponse({
                status: response.status,
                statusText: response.statusText,
                data: result,
                headers: Object.fromEntries(response.headers.entries())
            });
            
            if (result.status) {
                Swal.fire(
                    'Success!',
                    'API test completed successfully. Check the test panel below for details.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Test Failed!',
                    `API test failed: ${result.message || 'Unknown error'}`,
                    'error'
                );
            }
        } catch (error) {
            setTestResponse({
                error: true,
                message: error.message
            });
            Swal.fire(
                'Test Error!',
                `Error during API test: ${error.message}`,
                'error'
            );
        } finally {
            setTestLoadingId(null);
        }
    };

    const handleDelete = async (apiId) => {
        const result = await Swal.fire({
            title: 'Delete API Configuration',
            text: "Are you sure you want to delete this API? This action cannot be undone.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {
                const token = getToken();
                const myHeaders = new Headers();
                myHeaders.append('Authorization', `Bearer ${token}`);
                myHeaders.append('Content-Type', 'application/json');
                
                // Base64 encode the API ID as required by the endpoint
                const encodedId = btoa(apiId.toString());
                
                const response = await fetch(`${domain()}/api_model/${encodedId}`, {
                    method: 'DELETE',
                    headers: myHeaders
                });
                
                const result = await response.json();
                if (result.status) {
                    setApis(apis.filter(api => api.id !== apiId));
                    Swal.fire(
                        'Deleted!',
                        'API has been deleted successfully.',
                        'success'
                    );
                } else {
                    Swal.fire(
                        'Error!',
                        `Failed to delete API: ${result.message}`,
                        'error'
                    );
                }
            } catch (error) {
                Swal.fire(
                    'Error!',
                    `Error deleting API: ${error.message}`,
                    'error'
                );
            }
        }
    };

    const handleAddHeader = async () => {
        if (newHeader.key.trim() && newHeader.value.trim()) {
            const newHeaderWithId = { ...newHeader, id: Date.now() };
            const updatedHeaderData = [...headerData, newHeaderWithId];
            console.log('🔄 Adding new header:', newHeaderWithId);
            console.log('🔄 Updated header data:', updatedHeaderData);
            setHeaderData(updatedHeaderData);
            setNewHeader({ key: '', type: 'Static Value', value: '' });
            setShowHeaderForm(false);
            
            // Save to API
            console.log('🔄 Auto-saving header data after adding new header...');
            await saveHeaderDataToAPI(updatedHeaderData);
        }
    };

    const handleRemoveHeader = async (headerId) => {
        const updatedHeaderData = headerData.filter(header => header.id !== headerId);
        setHeaderData(updatedHeaderData);
        
        // Save to API
        console.log('🔄 Auto-saving header data after removing header...');
        await saveHeaderDataToAPI(updatedHeaderData);
    };

    const handleAddBody = async () => {
        if (newBody.key.trim() && newBody.value.trim()) {
            const newBodyWithId = { ...newBody, id: Date.now() };
            const updatedBodyData = [...bodyData, newBodyWithId];
            setBodyData(updatedBodyData);
            setNewBody({ key: '', type: 'Static Value', value: '' });
            setShowBodyForm(false);
            
            // Save to API based on format
            console.log('🔄 Auto-saving body data after adding new body field...');
            if (bodyFormat === 'JSON') {
                await saveJsonDataToAPI(jsonData);
            } else {
                await saveBodyDataToAPI(updatedBodyData, bodyFormat);
            }
        };
    };

    const handleRemoveBody = async (bodyId) => {
        const updatedBodyData = bodyData.filter(body => body.id !== bodyId);
        setBodyData(updatedBodyData);
        
        // Save to API based on format
        console.log('🔄 Auto-saving body data after removing body field...');
        if (bodyFormat === 'JSON') {
            await saveJsonDataToAPI(jsonData);
        } else {
            await saveBodyDataToAPI(updatedBodyData, bodyFormat);
        }
    };

    // Handler for JSON data changes
    const handleJsonDataChange = async (e) => {
        const newJsonData = e.target.value;
        setJsonData(newJsonData);
        
        // Auto-save JSON data to API if it's valid
        if (newJsonData.trim()) {
            try {
                JSON.parse(newJsonData);
                console.log('🔄 Auto-saving JSON data after change...');
                await saveJsonDataToAPI(newJsonData);
            } catch (error) {
                console.log('JSON data is not valid yet, skipping auto-save');
            }
        }
    };

    // Handler for body format changes
    const handleBodyFormatChange = async (newFormat) => {
        console.log('🔄 Body format changing from', bodyFormat, 'to', newFormat);
        
        // Save current data before switching formats
        if (bodyFormat === 'JSON' && jsonData.trim()) {
            console.log('🔄 Saving current JSON data before format change...');
            await saveJsonDataToAPI(jsonData);
        } else if ((bodyFormat === 'DEFAULT' || bodyFormat === 'FORM-DATA' || bodyFormat === 'X-WWW-FORM-URLENCODED') && bodyData.length > 0) {
            console.log('🔄 Saving current body data before format change...');
            await saveBodyDataToAPI(bodyData, bodyFormat);
        }
        
        setBodyFormat(newFormat);
        console.log('✅ Body format changed to:', newFormat);
    };

    const filteredApis = apis.filter(api => {
        const matchesSearch = api.name.toLowerCase().includes(filters.search.toLowerCase()) ||
                            api.endpointUrl.toLowerCase().includes(filters.search.toLowerCase());
        const matchesStatus = filters.status === 'Any Status' || 
                            (filters.status === 'Active' && api.status) ||
                            (filters.status === 'Inactive' && !api.status);
        const matchesVerification = filters.verification === 'Any Verification' ||
                                  (filters.verification === 'Verified' && api.verified) ||
                                  (filters.verification === 'Unverified' && !api.verified);
        
        return matchesSearch && matchesStatus && matchesVerification;
    });

    const paginatedApis = filteredApis.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const totalPages = Math.ceil(filteredApis.length / rowsPerPage);

    const clearForm = () => {
        setEndpointUrl('');
        setMethod('GET');
        setModelName('');
        setHeaderData([]);
        setBodyData([]);
        setJsonData('');
        setBodyFormat('DEFAULT');
        setIsEditMode(false);
        setEditingApiId(null);
    };

    const toggleFieldEditability = (fieldType, fieldId) => {
        if (fieldType === 'header') {
            setHeaderData(headerData.map(header => 
                header.id === fieldId 
                    ? { ...header, readOnly: header.readOnly === false ? true : false }
                    : header
            ));
        } else if (fieldType === 'body') {
            setBodyData(bodyData.map(body => 
                body.id === fieldId 
                    ? { ...body, readOnly: body.readOnly === false ? true : false }
                    : body
            ));
        }
    };

    const handleCreateApi = async () => {
        setCreateApiLoading(true);
        
        try {
            const token = getToken();
            const myHeaders = new Headers();
            myHeaders.append('Authorization', `Bearer ${token}`);
            myHeaders.append('Content-Type', 'application/json');

            // Convert headerData array to array format [key: value] and then to JSON string
            const headersArray = Array.isArray(headerData)
                ? headerData.map(header => ({ [header.key]: header.value }))
                : [];

            // Prepare body data (reuse logic from testApiConnection)
            let form_data = [];
            let x_www_from_urlencoded_data = "";
            let raw_data = "";
            let finalHeadersArray = [...headersArray];
            
            if (bodyFormat === 'JSON' && jsonData.trim()) {
                raw_data = jsonData;
                finalHeadersArray.push({ "Content-Type": "application/json" });
            } else if (bodyFormat === 'FORM-DATA' && Array.isArray(bodyData) && bodyData.length > 0) {
                form_data = bodyData.map(body => ({ key: body.key, value: body.value }));
            } else if (bodyFormat === 'X-WWW-FORM-URLENCODED' && Array.isArray(bodyData) && bodyData.length > 0) {
                x_www_from_urlencoded_data = bodyData.map(body => `${encodeURIComponent(body.key)}=${encodeURIComponent(body.value)}`).join('&');
            } else if (bodyFormat === 'DEFAULT' && Array.isArray(bodyData) && bodyData.length > 0) {
                const jsonObject = {};
                bodyData.forEach(body => { jsonObject[body.key] = body.value; });
                raw_data = JSON.stringify(jsonObject);
            }

            // Convert final headers array to JSON string as required by the API
           // const headersString = JSON.stringify(finalHeadersArray);
           const headersString = finalHeadersArray;


            const apiModel = {
                model_name: modelName || "default_model",
                url: endpointUrl,
                method: method,
                header: headersString, // Send as JSON string instead of array
                form_data: form_data,
                x_www_form_urlencoded_data: x_www_from_urlencoded_data,
                raw_data: raw_data,
                binary_data: ""
            };

            let response;
            if (isEditMode && editingApiId) {
                // Update existing API
                response = await fetch(`${domain()}/api_model/${btoa(editingApiId)}`, {
                    method: 'PUT',
                    headers: myHeaders,
                    body: JSON.stringify(apiModel)
                });
            } else {
                // Create new API
                response = await fetch(`${domain()}/api_model`, {
                    method: 'POST',
                    headers: myHeaders,
                    body: JSON.stringify(apiModel)
                });
            }
            
            const result = await response.json();
            if (result.status || result.success) {
                Swal.fire(
                    'Success!',
                    isEditMode ? 'API Updated Successfully!' : 'API Created Successfully!',
                    'success'
                );
                // Refresh the API list
                fetchApiModels();
                // Clear form and reset edit mode
                clearForm();
            } else {
                Swal.fire(
                    'Error!',
                    `Failed to ${isEditMode ? 'update' : 'create'} API: ${result.message || 'Unknown error'}`,
                    'error'
                );
            }
        } catch (error) {
            Swal.fire(
                'Error!',
                `Error creating API: ${error.message}`,
                'error'
            );
        } finally {
            setCreateApiLoading(false);
        }
    };

    return (
        <div className="api-model-container">
           
            <div className="api-model-content">
                <h2>Connected HTTP APIs</h2>
                
                <div className="filters-section">
                    <div className="filters-left">
                        <select 
                            value={filters.status}
                            onChange={(e) => setFilters({...filters, status: e.target.value})}
                            className="filter-dropdown"
                        >
                            <option>Any Status</option>
                            <option>Active</option>
                            <option>Inactive</option>
                        </select>
                        
                        <select 
                            value={filters.verification}
                            onChange={(e) => setFilters({...filters, verification: e.target.value})}
                            className="filter-dropdown"
                        >
                            <option>Any Verification</option>
                            <option>Verified</option>
                            <option>Unverified</option>
                        </select>
                        
                        <input 
                            type="text"
                            placeholder="Search & Enter..."
                            value={filters.search}
                            onChange={(e) => setFilters({...filters, search: e.target.value})}
                            className="search-input"
                        />
                    </div>
                    
                    <div className="filters-right">
                        <button className="report-btn">
                            <i className="typcn typcn-eye"></i>
                            HTTP API Report
                        </button>
                        <button className="import-btn">
                            <i className="typcn typcn-folder"></i>
                            Import HTTP API Settings
                        </button>
                    </div>
                </div>

                <div className="table-container">
                    <table className="api-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>API Name</th>
                                <th>Endpoint URL</th>
                                <th>Method</th>
                                <th>Status</th>
                                <th>Verified</th>
                                <th>Actions</th>
                                <th>Created at</th>
                                <th>Last Called at</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="9" className="text-center py-5">
                                        <div className="text-muted">
                                            <Preloader action={loading} />
                                            <p className="mt-2">Loading APIs...</p>
                                        </div>
                                    </td>
                                </tr>
                            ) : paginatedApis.length === 0 ? (
                                <tr>
                                    <td colSpan="9" className="text-center py-5">
                                        <div className="text-muted">
                                            <i className="typcn typcn-search" style={{ fontSize: '3rem', color: '#d1d3e2', marginBottom: '1rem' }}></i>
                                            <h5 style={{ color: '#858796', marginBottom: '0.5rem' }}>No APIs found</h5>
                                            <p style={{ color: '#b7b9cc', fontSize: '0.875rem' }}>
                                                {filters.search 
                                                    ? 'Try adjusting your search criteria' 
                                                    : 'Get started by creating your first API'
                                                }
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                paginatedApis.map((api, index) => (
                                    <tr key={api.id}>
                                        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                                        <td>
                                            <div className="api-name">
                                                <i className="typcn typcn-arrow-forward"></i>
                                                {api.name}
                                                {isEditMode && editingApiId === api.id && (
                                                    <span style={{
                                                        background: '#075E54',
                                                        color: 'white',
                                                        fontSize: '10px',
                                                        padding: '2px 6px',
                                                        borderRadius: '10px',
                                                        marginLeft: '8px',
                                                        fontWeight: 'normal'
                                                    }}>
                                                        Editing
                                                    </span>
                                                )}
                                            </div>
                                        </td>
                                        <td className="endpoint-url">{api.endpointUrl}</td>
                                        <td>
                                            <span style={{
                                                backgroundColor: '#e3f2fd',
                                                color: '#1976d2',
                                                padding: '0.25rem 0.75rem',
                                                borderRadius: '0.35rem',
                                                fontSize: '0.75rem',
                                                fontWeight: '500',
                                                border: '1px solid #bbdefb'
                                            }}>
                                                {api.method}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="status-toggle-container">
                                                <label className="toggle-switch theme-colored">
                                                    <input 
                                                        type="checkbox"
                                                        checked={api.status}
                                                        onChange={() => handleStatusToggle(api.id)}
                                                    />
                                                    <span className="slider"></span>
                                                </label>
                                                <span 
                                                    className="status-label" 
                                                    style={{ 
                                                        color: api.status ? theme.color.companyColor : '#6c757d',
                                                        fontWeight: api.status ? '600' : '500',
                                                        opacity: api.status ? '1' : '0.8'
                                                    }}
                                                >
                                                    {api.status ? 'ACTIVE' : 'INACTIVE'}
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="verified-status">
                                                {api.verified ? (
                                                    <>
                                                        <i className="typcn typcn-tick text-success"></i>
                                                        <span>Yes</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="typcn typcn-times text-danger"></i>
                                                        <span>No</span>
                                                    </>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="action-buttons">
                                                <button 
                                                    className="action-btn"
                                                    onClick={() => handleEdit(api.id)}
                                                    title="Edit"
                                                    disabled={editLoading}
                                                    style={{
                                                        backgroundColor: editLoading ? '#6c757d' : '#075E54',
                                                        borderColor: editLoading ? '#6c757d' : '#075E54',
                                                        color: 'white',
                                                        cursor: editLoading ? 'not-allowed' : 'pointer'
                                                    }}
                                                >
                                                    {editLoading && editingApiId === api.id ? (
                                                        <i className="typcn typcn-loading" style={{ animation: 'spin 1s linear infinite' }}></i>
                                                    ) : (
                                                        <i className="typcn typcn-edit"></i>
                                                    )}
                                                </button>
                                                <button 
                                                    className="action-btn"
                                                    onClick={() => handleShare(api.id)}
                                                    title="Share"
                                                    style={{
                                                        backgroundColor: '#075E54',
                                                        borderColor: '#075E54',
                                                        color: 'white'
                                                    }}
                                                >
                                                    <i className="typcn typcn-export"></i>
                                                </button>
                                                <button 
                                                    className="action-btn"
                                                    onClick={() => handleTest(api.id)}
                                                    title="Test"
                                                    disabled={testLoadingId === api.id}
                                                    style={{
                                                        backgroundColor: '#075E54',
                                                        borderColor: '#075E54',
                                                        color: 'white'
                                                    }}
                                                >
                                                    {testLoadingId === api.id ? (
                                                        <i className="typcn typcn-loading"></i>
                                                    ) : (
                                                        <i className="typcn typcn-flash"></i>
                                                    )}
                                                </button>
                                                <button 
                                                    className="action-btn"
                                                    onClick={() => handleDelete(api.id)}
                                                    title="Delete"
                                                    style={{
                                                        backgroundColor: '#dc3545',
                                                        borderColor: '#dc3545',
                                                        color: 'white'
                                                    }}
                                                >
                                                    <i className="typcn typcn-delete"></i>
                                                </button>
                                            </div>
                                        </td>
                                        <td>{api.createdAt}</td>
                                        <td>
                                            <div className="last-called">
                                                {api.lastCalledAt}
                                                <i className="typcn typcn-arrow-sorted-down"></i>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination-section">
                    <div className="pagination-left">
                        <select 
                            value={rowsPerPage}
                            onChange={(e) => setRowsPerPage(Number(e.target.value))}
                            className="rows-per-page"
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                    
                    <div className="pagination-right">
                        <span className="pagination-info">
                            {((currentPage - 1) * rowsPerPage) + 1} - {Math.min(currentPage * rowsPerPage, filteredApis.length)} of {filteredApis.length}
                        </span>
                        
                        <div className="pagination-buttons">
                            <button 
                                className="pagination-btn"
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage(currentPage - 1)}
                            >
                                Previous
                            </button>
                            
                            {/* Dynamic page numbers */}
                            {Array.from({ length: totalPages }, (_, index) => {
                                const pageNumber = index + 1;
                                // Show current page, first page, last page, and pages around current
                                if (
                                    pageNumber === 1 || 
                                    pageNumber === totalPages || 
                                    (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
                                ) {
                                    return (
                                        <button 
                                            key={pageNumber}
                                            className={`pagination-btn ${currentPage === pageNumber ? 'active' : ''}`}
                                            onClick={() => setCurrentPage(pageNumber)}
                                        >
                                            {pageNumber}
                                        </button>
                                    );
                                } else if (
                                    pageNumber === currentPage - 2 || 
                                    pageNumber === currentPage + 2
                                ) {
                                    return <span key={pageNumber} className="pagination-ellipsis">...</span>;
                                }
                                return null;
                            })}
                            
                            <button 
                                className="pagination-btn"
                                disabled={currentPage === totalPages}
                                onClick={() => setCurrentPage(currentPage + 1)}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Loading with Custom Preloader */}
            {editLoading && (
                <div className="edit-loading-container">
                    <div className="edit-loading-content">
                        <Preloader action={editLoading} />
                        <h3>Loading API Configuration...</h3>
                        <p>Please wait while we fetch your API data</p>
                    </div>
                </div>
            )}

            {/* API Test Panel - Postman-like Interface */}
            {showTestPanel && (
                <div className="api-test-results" onClick={() => setShowTestPanel(false)}>

                    <div className="test-results-container" onClick={(e) => e.stopPropagation()}>
                        <div className="test-results-header">
                            <h3>
                                <i className="typcn typcn-flash"></i>
                                API Test Results
                            </h3>
                            <button className="close-test-panel" onClick={() => setShowTestPanel(false)}>
                                <i className="typcn typcn-times"></i>
                            </button>
                        </div>
                        <div className="test-results-tabs">
                            <button className={`test-tab ${testRequest ? 'active' : ''}`}>Request</button>
                            <button className={`test-tab ${testResponse ? 'active' : ''}`}>Response</button>
                        </div>
                        <div className="test-tab-content">
                            {/* Request Tab Content */}
                            <div className="request-info">
                                <div className="request-url-section">
                                    <div className="request-method-url">
                                        <span className="request-method" style={{
                                            backgroundColor: selectedApiForTest?.method === 'GET' ? '#61affe' : 
                                                selectedApiForTest?.method === 'POST' ? '#49cc90' :
                                                selectedApiForTest?.method === 'PUT' ? '#fca130' :
                                                selectedApiForTest?.method === 'DELETE' ? '#f93e3e' : '#61affe',
                                            color: 'white',
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                            fontSize: '12px',
                                            fontWeight: 'bold',
                                            marginRight: '10px'
                                        }}>{selectedApiForTest?.method || 'GET'}</span>
                                        <span className="request-url">{selectedApiForTest?.endpointUrl}</span>
                                    </div>
                                </div>
                                <div className="request-details">
                                    <div className="detail-section">
                                        <h4>Headers</h4>
                                        <div className="headers-display">
                                            {testRequest && testRequest.headers && Array.isArray(testRequest.headers) && testRequest.headers.length > 0 ? (
                                                testRequest.headers.map((header, index) => (
                                                    <div key={index} className="header-item">
                                                        <span className="header-key">{Object.keys(header)[0]}:</span>
                                                        <span className="header-value">{Object.values(header)[0]}</span>
                                                    </div>
                                                ))
                                            ) : (
                                                <span className="no-data">No headers</span>
                                            )}
                                        </div>
                                    </div>
                                    {testRequest && testRequest.body && (
                                        <div className="detail-section">
                                            <h4>Body</h4>
                                            <pre className="body-display">{JSON.stringify(testRequest.body, null, 2)}</pre>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* Response Tab Content */}
                            <div className="response-info">
                                {testResponse ? (
                                    <>
                                        <div className="response-status">
                                            <span className={`status-badge ${testResponse.status >= 200 && testResponse.status < 300 ? 'success' : 'error'}`}>
                                                {testResponse.status} {testResponse.statusText}
                                            </span>
                                            <span className="response-time">Response Time: ~{Math.floor(Math.random() * 500) + 100}ms</span>
                                        </div>
                                        <div className="detail-section">
                                            <h4>Response Headers</h4>
                                            <div className="headers-display">
                                                {testResponse.headers && Object.keys(testResponse.headers).length > 0 ? (
                                                    Object.entries(testResponse.headers).map(([key, value]) => (
                                                        <div key={key} className="header-item">
                                                            <span className="header-key">{key}:</span>
                                                            <span className="header-value">{value}</span>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <span className="no-data">No response headers</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="detail-section">
                                            <h4>Response Body</h4>
                                            <pre className="response-body h-[300px]">
                                                {testResponse.error ? testResponse.message : JSON.stringify(testResponse.data, null, 2)}
                                            </pre>
                                        </div>
                                    </>
                                ) : (
                                    <div className="loading-response">
                                        <i className="typcn typcn-loading"></i>
                                        <span>Waiting for response...</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showCreateModal && (
                <CreateApiModal 
                    onClose={() => setShowCreateModal(false)}
                    onSave={(newApi) => {
                        setApis([...apis, { ...newApi, id: Date.now() }]);
                        setShowCreateModal(false);
                    }}
                />
            )}

            {/* API Connection Details Section */}
            <div className="api-connection-details">
                <div className="connection-header">
                    <h2>
                        {isEditMode ? (
                            <>
                                <i className="typcn typcn-edit" style={{ color: '#075E54', marginRight: '10px' }}></i>
                                Edit API Configuration
                            </>
                        ) : (
                            'API Connection Details'
                        )}
                    </h2>
                    <p>
                        {isEditMode 
                            ? `Editing API ID: ${editingApiId} - Modify the configuration below`
                            : 'Build & verify a HTTP API connection'
                        }
                    </p>
                    {isEditMode && (
                        <div className="edit-mode-indicator" style={{
                            background: '#e3f2fd',
                            color: '#1976d2',
                            padding: '8px 16px',
                            borderRadius: '20px',
                            fontSize: '14px',
                            fontWeight: '500',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            marginTop: '10px'
                        }}>
                            <i className="typcn typcn-info-large"></i>
                            Edit Mode Active - Changes will update the existing API
                        </div>
                    )}
                </div>
                
                <div className="connection-form">
                    <div className="form-row">
                        
                        
                        <div className="form-group">
                            <label>
                                <i className="typcn typcn-cog"></i>
                                MODEL NAME 
                                {isEditMode && (
                                    <span style={{
                                        background: '#4caf50',
                                        color: 'white',
                                        fontSize: '10px',
                                        padding: '2px 6px',
                                        borderRadius: '10px',
                                        marginLeft: '8px',
                                        fontWeight: 'normal'
                                    }}>
                                        Loaded
                                    </span>
                                )}
                            </label>
                            <input 
                                type="text"
                                value={modelName}
                                onChange={(e) => setModelName(e.target.value)}
                                placeholder="Enter model name"
                                className="form-control"
                                required
                                style={{
                                    borderColor: isEditMode ? '#4caf50' : undefined,
                                    background: isEditMode ? '#f8fff8' : undefined
                                }}
                            />
                        </div>
                        
                        <div className="form-group">
                            <label>
                                METHOD *
                                {isEditMode && (
                                    <span style={{
                                        background: '#4caf50',
                                        color: 'white',
                                        fontSize: '10px',
                                        padding: '2px 6px',
                                        borderRadius: '10px',
                                        marginLeft: '8px',
                                        fontWeight: 'normal'
                                    }}>
                                        Loaded
                                    </span>
                                )}
                            </label>
                            <select 
                                className="form-control" 
                                value={method}
                                onChange={(e) => setMethod(e.target.value)}
                                required
                                style={{
                                    borderColor: isEditMode ? '#4caf50' : undefined,
                                    background: isEditMode ? '#f8fff8' : undefined
                                }}
                            >
                                <option value="">Select Method</option>
                                <option value="GET">GET</option>
                                <option value="POST">POST</option>
                                <option value="PUT">PUT</option>
                                <option value="DELETE">DELETE</option>
                            </select>
                        </div>
                        
                        <div className="form-group">
                            <label>
                                <i className="typcn typcn-user"></i>
                                TEST SUBSCRIBER ID *
                                <i className="typcn typcn-info-large"></i>
                            </label>
                            <input 
                                type="text"
                                placeholder="Enter subscriber ID"
                                className="form-control"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="form-group">
                        <label>
                            <i className="typcn typcn-link"></i>
                            END-POINT URL *
                            <i className="typcn typcn-th-list"></i>
                            {isEditMode && (
                                <span style={{
                                    background: '#4caf50',
                                    color: 'white',
                                    fontSize: '10px',
                                    padding: '2px 6px',
                                    borderRadius: '10px',
                                    marginLeft: '8px',
                                    fontWeight: 'normal'
                                }}>
                                    Loaded
                                </span>
                            )}
                        </label>
                        <input 
                            type="url"
                            value={endpointUrl}
                            onChange={(e) => setEndpointUrl(e.target.value)}
                            placeholder="Enter endpoint URL"
                            className="form-control"
                            required
                            style={{
                                borderColor: isEditMode ? '#4caf50' : undefined,
                                background: isEditMode ? '#f8fff8' : undefined
                            }}
                        />
                    </div>
                    
                    <div className="data-sections-grid">
                        <div className="data-section-card">
                            <div className="section-header">
                                <h4>
                                    Header Data
                                    {isEditMode && headerData.length > 0 && (
                                        <span style={{
                                            background: '#4caf50',
                                            color: 'white',
                                            fontSize: '10px',
                                            padding: '2px 6px',
                                            borderRadius: '10px',
                                            marginLeft: '8px',
                                            fontWeight: 'normal'
                                        }}>
                                            {headerData.length} Loaded
                                        </span>
                                    )}
                                </h4>
                                <button 
                                    type="button" 
                                    className="add-btn"
                                    onClick={() => setShowHeaderForm(true)}
                                >
                                    + Add
                                </button>
                            </div>
                            <div className="section-content">
                                {/* Debug info - remove this in production */}
                                
                                
                                {headerData.length === 0 && !showHeaderForm ? (
                                    <div className="empty-state">
                                        <i className="typcn typcn-plus"></i>
                                        <span>No headers added yet. Click the "+ Add" button above to get started.</span>
                                    </div>
                                ) : (
                                    <div className="header-fields-container">
                                        {headerData.map((header, index) => (
                                            <div key={header.id} className="header-field-row">
                                                {/* Debug info for each header */}
                                                
                                                <div className="header-field">
                                                    <label>HEADER : KEY *</label>
                                                    <input 
                                                        type="text" 
                                                        value={header.key}
                                                        readOnly={header.readOnly === true}
                                                        onChange={(e) => {
                                                            setHeaderData(headerData.map(h => 
                                                                h.id === header.id 
                                                                    ? { ...h, key: e.target.value }
                                                                    : h
                                                            ));
                                                        }}
                                                        placeholder="Key"
                                                        style={{
                                                            borderColor: isEditMode ? '#4caf50' : undefined,
                                                            background: isEditMode ? '#f8fff8' : undefined
                                                        }}
                                                    />
                                                </div>
                                                <div className="header-field">
                                                    <label>HEADER : TYPE *</label>
                                                    <select 
                                                        value={header.type} 
                                                        disabled={header.readOnly === true}
                                                        onChange={(e) => {
                                                            setHeaderData(headerData.map(h => 
                                                                h.id === header.id 
                                                                    ? { ...h, type: e.target.value }
                                                                    : h
                                                            ));
                                                        }}
                                                    >
                                                        <option>Static Value</option>
                                                        <option>Dynamic Value</option>
                                                    </select>
                                                </div>
                                                <div className="header-field">
                                                    <label>HEADER : VALUE *</label>
                                                    <input 
                                                        type="text" 
                                                        value={header.value}
                                                        readOnly={header.readOnly === true}
                                                        onChange={(e) => {
                                                            setHeaderData(headerData.map(h => 
                                                                h.id === header.id 
                                                                    ? { ...h, value: e.target.value }
                                                                    : h
                                                            ));
                                                        }}
                                                        placeholder="Value"
                                                        style={{
                                                            borderColor: isEditMode ? '#4caf50' : undefined,
                                                            background: isEditMode ? '#f8fff8' : undefined
                                                        }}
                                                    />
                                                </div>
                                                <div className="header-actions">
                                                    {isEditMode && (
                                                        <button 
                                                            type="button" 
                                                            className="edit-btn"
                                                            onClick={() => toggleFieldEditability('header', header.id)}
                                                            style={{
                                                                background: header.readOnly === true ? '#ffc107' : '#28a745',
                                                                color: header.readOnly === true ? '#212529' : 'white',
                                                                border: 'none',
                                                                padding: '4px 8px',
                                                                borderRadius: '4px',
                                                                fontSize: '12px',
                                                                marginRight: '5px'
                                                            }}
                                                        >
                                                            <i className={`typcn ${header.readOnly === true ? 'typcn-edit' : 'typcn-tick'}`}></i>
                                                            {header.readOnly === true ? 'Edit' : 'Done'}
                                                        </button>
                                                    )}
                                                    <button 
                                                        type="button" 
                                                        className="remove-btn"
                                                        onClick={() => handleRemoveHeader(header.id)}
                                                    >
                                                        <i className="typcn typcn-times"></i>
                                                        Remove
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                        
                                        {showHeaderForm && (
                                            <div className="header-field-row">
                                                <div className="header-field">
                                                    <label>HEADER : KEY *</label>
                                                    <input 
                                                        type="text" 
                                                        value={newHeader.key}
                                                        onChange={(e) => setNewHeader({...newHeader, key: e.target.value})}
                                                        placeholder="Key"
                                                    />
                                                </div>
                                                <div className="header-field">
                                                    <label>HEADER : TYPE *</label>
                                                    <select 
                                                        value={newHeader.type}
                                                        onChange={(e) => setNewHeader({...newHeader, type: e.target.value})}
                                                    >
                                                        <option>Static Value</option>
                                                        <option>Dynamic Value</option>
                                                    </select>
                                                </div>
                                                <div className="header-field">
                                                    <label>HEADER : VALUE *</label>
                                                    <input 
                                                        type="text" 
                                                        value={newHeader.value}
                                                        onChange={(e) => setNewHeader({...newHeader, value: e.target.value})}
                                                        placeholder="Value"
                                                    />
                                                </div>
                                                <div className="header-actions">
                                                    <button 
                                                        type="button" 
                                                        className="add-header-btn"
                                                        onClick={handleAddHeader}
                                                    >
                                                        <i className="typcn typcn-plus"></i>
                                                        Add
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        
                        <div className="data-section-card">
                            <div className="section-header">
                                <h4>
                                    Body Data
                                    {isEditMode && (
                                        bodyFormat === 'JSON' && jsonData ? (
                                            <span style={{
                                                background: '#4caf50',
                                                color: 'white',
                                                fontSize: '10px',
                                                padding: '2px 6px',
                                                borderRadius: '10px',
                                                marginLeft: '8px',
                                                fontWeight: 'normal'
                                            }}>
                                                JSON Loaded
                                            </span>
                                        ) : bodyData.length > 0 ? (
                                            <span style={{
                                                background: '#4caf50',
                                                color: 'white',
                                                fontSize: '10px',
                                                padding: '2px 6px',
                                                borderRadius: '10px',
                                                marginLeft: '8px',
                                                fontWeight: 'normal'
                                            }}>
                                                {bodyData.length} Loaded
                                            </span>
                                        ) : null
                                    )}
                                </h4>
                                <button 
                                    type="button" 
                                    className="add-btn"
                                    onClick={() => setShowBodyForm(true)}
                                >
                                    + Add
                                </button>
                            </div>
                            <div className="format-toggles">
                               
                                
                                
                                <button 
                                    type="button" 
                                    className={`format-btn ${bodyFormat === 'DEFAULT' ? 'active' : ''}`}
                                    onClick={() => handleBodyFormatChange('DEFAULT')}
                                >
                                    DEFAULT
                                </button>
                                <button 
                                    type="button" 
                                    className={`format-btn ${bodyFormat === 'FORM-DATA' ? 'active' : ''}`}
                                    onClick={() => handleBodyFormatChange('FORM-DATA')}
                                >
                                    FORM-DATA
                                </button>
                                <button 
                                    type="button" 
                                    className={`format-btn ${bodyFormat === 'X-WWW-FORM-URLENCODED' ? 'active' : ''}`}
                                    onClick={() => handleBodyFormatChange('X-WWW-FORM-URLENCODED')}
                                >
                                    X-WWW-FORM-URLENCODED
                                </button>
                                <button 
                                    type="button" 
                                    className={`format-btn ${bodyFormat === 'JSON' ? 'active' : ''}`}
                                    onClick={() => handleBodyFormatChange('JSON')}
                                >
                                    JSON
                                </button>
                                <button 
                                    type="button" 
                                    className={`format-btn ${bodyFormat === 'BINARY' ? 'active' : ''}`}
                                    onClick={() => handleBodyFormatChange('BINARY')}
                                >
                                    BINARY
                                </button>
                            </div>
                            <div className="section-content">
                                {/* Show dynamic fields for DEFAULT, FORM-DATA, and X-WWW-FORM-URLENCODED formats */}
                                {(bodyFormat === 'DEFAULT' || bodyFormat === 'FORM-DATA' || bodyFormat === 'X-WWW-FORM-URLENCODED') ? (
                                    bodyData.length === 0 && !showBodyForm ? (
                                        <div className="empty-state">
                                            <i className="typcn typcn-plus"></i>
                                            <span>No body data added yet. Click the "+ Add" button above to get started.</span>
                                        </div>
                                    ) : (
                                        <div className="body-fields-container">
                                            {bodyData.map((body) => (
                                                <div key={body.id} className="body-field-row">
                                                    <div className="body-field">
                                                        <label>BODY : KEY *</label>
                                                        <input
                                                            type="text"
                                                            value={body.key}
                                                            readOnly={body.readOnly === true}
                                                            onChange={(e) => {
                                                                setBodyData(bodyData.map(b => 
                                                                    b.id === body.id 
                                                                        ? { ...b, key: e.target.value }
                                                                        : b
                                                                ));
                                                            }}
                                                            placeholder="Key"
                                                            style={{
                                                                borderColor: isEditMode ? '#4caf50' : undefined,
                                                                background: isEditMode ? '#f8fff8' : undefined
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="body-field">
                                                        <label>BODY : TYPE *</label>
                                                        <select 
                                                            value={body.type} 
                                                            disabled={body.readOnly === true}
                                                            onChange={(e) => {
                                                                setBodyData(bodyData.map(b => 
                                                                    b.id === body.id 
                                                                        ? { ...b, type: e.target.value }
                                                                        : b
                                                                ));
                                                            }}
                                                        >
                                                            <option>Static Value</option>
                                                            <option>Dynamic Value</option>
                                                        </select>
                                                    </div>
                                                    <div className="body-field">
                                                        <label>BODY : VALUE *</label>
                                                        <input
                                                            type="text"
                                                            value={body.value}
                                                            readOnly={body.readOnly === true}
                                                            onChange={(e) => {
                                                                setBodyData(bodyData.map(b => 
                                                                    b.id === body.id 
                                                                        ? { ...b, value: e.target.value }
                                                                        : b
                                                                ));
                                                            }}
                                                            placeholder="Value"
                                                            style={{
                                                                borderColor: isEditMode ? '#4caf50' : undefined,
                                                                background: isEditMode ? '#f8fff8' : undefined
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="body-actions">
                                                        {isEditMode && (
                                                            <button
                                                                type="button"
                                                                className="edit-btn"
                                                                onClick={() => toggleFieldEditability('body', body.id)}
                                                                style={{
                                                                    background: body.readOnly === true ? '#ffc107' : '#28a745',
                                                                    color: body.readOnly === true ? '#212529' : 'white',
                                                                    border: 'none',
                                                                    padding: '4px 8px',
                                                                    borderRadius: '4px',
                                                                    fontSize: '12px',
                                                                    marginRight: '5px'
                                                                }}
                                                            >
                                                                <i className={`typcn ${body.readOnly === true ? 'typcn-edit' : 'typcn-tick'}`}></i>
                                                                {body.readOnly === true ? 'Edit' : 'Done'}
                                                            </button>
                                                        )}
                                                        <button
                                                            type="button"
                                                            className="remove-btn"
                                                            onClick={() => handleRemoveBody(body.id)}
                                                        >
                                                            <i className="typcn typcn-times"></i>
                                                            Remove
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}

                                            {showBodyForm && (
                                                <div className="body-field-row">
                                                    <div className="body-field">
                                                        <label>BODY : KEY *</label>
                                                        <input
                                                            type="text"
                                                            value={newBody.key}
                                                            onChange={(e) => setNewBody({...newBody, key: e.target.value})}
                                                            placeholder="Key"
                                                        />
                                                    </div>
                                                    <div className="body-field">
                                                        <label>BODY : TYPE *</label>
                                                        <select
                                                            value={newBody.type}
                                                            onChange={(e) => setNewBody({...newBody, type: e.target.value})}
                                                        >
                                                            <option>Static Value</option>
                                                            <option>Dynamic Value</option>
                                                        </select>
                                                    </div>
                                                    <div className="body-field">
                                                        <label>BODY : VALUE *</label>
                                                        <input
                                                            type="text"
                                                            value={newBody.value}
                                                            onChange={(e) => setNewBody({...newBody, value: e.target.value})}
                                                            placeholder="Value"
                                                        />
                                                    </div>
                                                    <div className="body-actions">
                                                        <button
                                                            type="button"
                                                            className="add-body-btn"
                                                            onClick={handleAddBody}
                                                        >
                                                            <i className="typcn typcn-plus"></i>
                                                            Add
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )
                                ) : bodyFormat === 'JSON' ? (
                                    /* Show JSON interface */
                                    <div className="json-interface">
                                        <div className="json-main-content">
                                            <label className="json-label">
                                                BODY : JSON *
                                                {isEditMode && jsonData && (
                                                    <span style={{
                                                        background: '#4caf50',
                                                        color: 'white',
                                                        fontSize: '10px',
                                                        padding: '2px 6px',
                                                        borderRadius: '10px',
                                                        marginLeft: '8px',
                                                        fontWeight: 'normal'
                                                    }}>
                                                        Loaded
                                                    </span>
                                                )}
                                            </label>
                                            <textarea
                                                className="json-textarea"
                                                value={jsonData}
                                                onChange={handleJsonDataChange}
                                                placeholder="Enter JSON data here..."
                                                style={{
                                                    borderColor: isEditMode && jsonData ? '#4caf50' : undefined,
                                                    background: isEditMode && jsonData ? '#f8fff8' : undefined
                                                }}
                                            />
                                        </div>
                                        <div className="variables-sidebar">
                                            <div className="variables-header">
                                                <h4># BODY : VARIABLES</h4>
                                                <i className="typcn typcn-info-large"></i>
                                            </div>
                                            <div className="variables-search">
                                                <input
                                                    type="text"
                                                    placeholder="Search..."
                                                    value={variablesSearch}
                                                    onChange={(e) => setVariablesSearch(e.target.value)}
                                                    className="variables-search-input"
                                                />
                                                <button className="refresh-btn">
                                                    <i className="typcn typcn-refresh"></i>
                                                </button>
                                            </div>
                                            <div className="variables-list">
                                                {availableVariables
                                                    .filter(variable => 
                                                        variable.toLowerCase().includes(variablesSearch.toLowerCase())
                                                    )
                                                    .map((variable, index) => (
                                                        <div key={index} className="variable-item">
                                                            {variable}
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    /* Show different content for BINARY format */
                                    <div className="empty-state">
                                        <i className="typcn typcn-document-text"></i>
                                        <span>This format requires different input method. Please select DEFAULT, FORM-DATA, X-WWW-FORM-URLENCODED, or JSON to add data.</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        
                        <div className="data-section-card">
                            <div className="section-header">
                                <h4>Option Data</h4>
                                <button type="button" className="add-btn">+ Add</button>
                            </div>
                            <div className="section-content">
                                {/* Option data content will go here */}
                            </div>
                        </div>
                        
                        <div className="data-section-card">
                            <div className="section-header">
                                <h4>Cookie Data</h4>
                                <button type="button" className="add-btn">+ Add</button>
                            </div>
                            <div className="section-content">
                                {/* Cookie data content will go here */}
                            </div>
                        </div>
                    </div>
                    
                    {/* Create/Update API Button */}
                    <div className="api-test-section">
                        <div className="button-group">
                            <button
                                type="button"
                                className="create-api-btn"
                                onClick={handleCreateApi}
                                disabled={createApiLoading}
                                style={{ 
                                    background: '#075E54', 
                                    color: '#fff', 
                                    padding: '12px 24px', 
                                    border: 'none', 
                                    borderRadius: '6px', 
                                    fontWeight: 600, 
                                    cursor: createApiLoading ? 'not-allowed' : 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    fontSize: '14px',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                {createApiLoading ? (
                                    <>
                                        <i className="typcn typcn-loading" style={{ animation: 'spin 1s linear infinite' }}></i>
                                        {isEditMode ? 'Updating API...' : 'Creating API...'}
                                    </>
                                ) : (
                                    <>
                                        <i className={isEditMode ? 'typcn typcn-edit' : 'typcn typcn-plus'}></i>
                                        {isEditMode ? 'Update API' : 'Create API'}
                                    </>
                                )}
                            </button>
                            
                            {isEditMode && (
                                <button
                                    type="button"
                                    className="cancel-edit-btn"
                                    onClick={clearForm}
                                    style={{ 
                                        background: '#6c757d', 
                                        color: '#fff', 
                                        padding: '12px 24px', 
                                        border: 'none', 
                                        borderRadius: '6px', 
                                        fontWeight: 600, 
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        fontSize: '14px',
                                        transition: 'all 0.3s ease',
                                        marginLeft: '10px'
                                    }}
                                >
                                    <i className="typcn typcn-times"></i>
                                    Cancel Edit
                                </button>
                            )}
                        </div>
                        <p className="test-info">
                            {isEditMode 
                                ? 'Click to update the existing API with the modified configuration'
                                : 'Click to create a new API with the configured data (Headers, Body, etc.)'
                            }
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const CreateApiModal = ({ onClose, onSave }) => {
    const [formData, setFormData] = useState({
        apiName: '',
        method: '',
        testSubscriberId: '',
        endpointUrl: '',
        headerData: [],
        bodyData: [],
        optionData: [],
        cookieData: []
    });

    const [bodyFormat, setBodyFormat] = useState('DEFAULT');

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h3>API Connection Details</h3>
                    <p>Build & verify a HTTP API connection</p>
                    <button className="close-btn" onClick={onClose}>
                        <i className="typcn typcn-times"></i>
                    </button>
                </div>
                
                <form onSubmit={handleSubmit}>
                    <div className="form-row">
                        <div className="form-group">
                            <label>API NAME</label>
                            <input 
                                type="text"
                                value={formData.apiName}
                                onChange={(e) => setFormData({...formData, apiName: e.target.value})}
                                placeholder="Enter API name"
                            />
                        </div>
                        
                        <div className="form-group">
                            <label>METHOD *</label>
                            <select 
                                value={formData.method}
                                onChange={(e) => setFormData({...formData, method: e.target.value})}
                                required
                            >
                                <option value="">Select Method</option>
                                <option value="GET">GET</option>
                                <option value="POST">POST</option>
                                <option value="PUT">PUT</option>
                                <option value="DELETE">DELETE</option>
                            </select>
                        </div>
                        
                        <div className="form-group">
                            <label>TEST SUBSCRIBER ID *</label>
                            <input 
                                type="text"
                                value={formData.testSubscriberId}
                                onChange={(e) => setFormData({...formData, testSubscriberId: e.target.value})}
                                placeholder="Enter subscriber ID"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="form-group">
                        <label>END-POINT URL *</label>
                        <input 
                            type="url"
                            value={formData.endpointUrl}
                            onChange={(e) => setFormData({...formData, endpointUrl: e.target.value})}
                            placeholder="Enter endpoint URL"
                            required
                        />
                    </div>
                    
                    <div className="data-sections">
                        <div className="data-section">
                            <h4>Header Data</h4>
                            <button type="button" className="add-btn">+ Add</button>
                        </div>
                        
                        <div className="data-section">
                            <h4>Body Data</h4>
                            <div className="format-toggles">
                                <button 
                                    type="button"
                                    className={`format-btn ${bodyFormat === 'DEFAULT' ? 'active' : ''}`}
                                    onClick={() => setBodyFormat('DEFAULT')}
                                >
                                    DEFAULT
                                </button>
                                <button 
                                    type="button"
                                    className={`format-btn ${bodyFormat === 'FORM-DATA' ? 'active' : ''}`}
                                    onClick={() => setBodyFormat('FORM-DATA')}
                                >
                                    FORM-DATA
                                </button>
                                <button 
                                    type="button"
                                    className={`format-btn ${bodyFormat === 'X-WWW-FORM-URLENCODED' ? 'active' : ''}`}
                                    onClick={() => setBodyFormat('X-WWW-FORM-URLENCODED')}
                                >
                                    X-WWW-FORM-URLENCODED
                                </button>
                                <button 
                                    type="button"
                                    className={`format-btn ${bodyFormat === 'JSON' ? 'active' : ''}`}
                                    onClick={() => setBodyFormat('JSON')}
                                >
                                    JSON
                                </button>
                                <button 
                                    type="button"
                                    className={`format-btn ${bodyFormat === 'BINARY' ? 'active' : ''}`}
                                    onClick={() => setBodyFormat('BINARY')}
                                >
                                    BINARY
                                </button>
                            </div>
                            <button type="button" className="add-btn">+ Add</button>
                        </div>
                        
                        <div className="data-section">
                            <h4>Option Data</h4>
                            <button type="button" className="add-btn">+ Add</button>
                        </div>
                        
                        <div className="data-section">
                            <h4>Cookie Data</h4>
                            <button type="button" className="add-btn">+ Add</button>
                        </div>
                    </div>
                    
                    <div className="modal-actions">
                        <button type="button" className="cancel-btn" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="save-btn">
                            Save API
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ApiModel; 